<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title fw-bold">
            <span  jhiTranslate="study-editor.geojson.title"></span>&nbsp;&nbsp;<span class="badge bg-secondary">BETA</span>&nbsp;
            <jhi-help-link [helpLink]="helpLink"></jhi-help-link>
        </h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
                (click)="cancel()">
        </button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-xs-12 col-md-12">
                <iframe [src]="safeUrl" style="border: 0" width="100%" height="900"></iframe>
            </div>
        </div>
    </div>
</div>
